/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Fieldset } from 'primereact/fieldset';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import * as moment from 'moment';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { mascaraCpf } from '../../modulos/mascaraCpf/index';

import { opEstadoCivil, opPagamento, opMensalidade } from './opcoes';
import  { somaTotalDependentes } from  '../../modulos/function/somaTotalDependentes';
import { atualizaMensalidade } from '../../services/contratos';
import calculateValorTotal from '../../modulos/calcPrime';
import { atualizarAdesao } from '../../modulos/atualizarAdesao';
import './style.css';

import servicosAdicionaisService from '../../services/servicosAdicionais/servicosAdicionaisService';

export default function Resumo({  Associado, inscricao, setShowModal, setLoading, showModal, Dependentes }){
    const history = useHistory();

    const [mensalidadeBase, setMensalidadeBase] = useState(0);
    const [somaBase, setSomaBase] = useState(0);
    const [valorServicosAdicionais ,setValorServicosAdicionais] = useState(0);

    useEffect(()=>{
        (async()=>{
            const servicosAdicionaisCadastrados = await servicosAdicionaisService.buscarServicosAdicionaisCadastrados(inscricao);
            const total = servicosAdicionaisCadastrados.reduce((accumulator, currentValue)=>accumulator + currentValue.Taxa.valor,0);

            setValorServicosAdicionais(total);
        })();
    },[]);

    useEffect(() => {
        let totalDeMensalidades;

        switch (Associado.SubGrupo) {
        case 'ZPCA ':
            totalDeMensalidades = 11;
            setMensalidadeBase(
                Associado['ProdutosPreco.valorBase'] / totalDeMensalidades
            );
            break;
        case 'ZPC4 ':
            totalDeMensalidades = 47;
            setMensalidadeBase(
                Associado['ProdutosPreco.valorBase'] / totalDeMensalidades
            );
            break;
        default:
            setMensalidadeBase(Associado['ProdutosPreco.valorBase']);
            break;
        }
    }, [Associado]);

    useEffect(() => {
        const totalDependentes = somaTotalDependentes(Dependentes);
        const resultSoma = calculateValorTotal(Associado, totalDependentes,valorServicosAdicionais);

        atualizarAdesao(inscricao, Associado, totalDependentes);

        if (Object.keys(Dependentes).length !== 0) {
            if (resultSoma) {
                setSomaBase(resultSoma.valorTotal);
            }
        } else {
            setSomaBase(resultSoma?.valorTotal);
        }
    }, [Dependentes, valorServicosAdicionais]);

    const saveMensalidade = async () => {
        await atualizaMensalidade(inscricao)
            .then(response => response)
            .catch(error => {
                alert('Ocorreu um erro para salvar as mensalidades! Erro: ', error);
            });
    };

    const finalizar = async () => {
        setShowModal(false);
        setLoading(true);
        await saveMensalidade();
        localStorage.removeItem('dadosUltimoContrato');
        history.push(`/assinatura/${inscricao}`);
    };

    const renderFooter = () => (
        <>
            <Button
                label="Continuar"
                icon="pi pi-check"
                iconPos="left"
                className="p-button-primary"
                onClick={() => {
                    finalizar();
                }}
            />
            <Button 
                disabled={Associado?.Aceite === 'S'}
                onClick= {()=> {history.push(`/editar-contrato/${inscricao}`);}}
                label="Editar Contrato" 
                type="submit" 
            />
        </>
    );

    return   <Dialog
        style={{ width: '80%',
            height: '100vh' }}
        header="Visualização do Contrato"
        keepInViewport={true}
        visible={showModal}
        onHide={() => setShowModal(false)}
        footer={renderFooter(setShowModal)}
    >
        <Card style={{ height: '100vh',
            marginTop:'5rem' }}>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                    <Fieldset legend="Contratante">
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-12">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Nome"
                                        className="p-col-fixed p-col-12 p-md-1"
                                    >
                                    Nome
                                    </label>
                                    <div className="p-col-12 p-md-11">
                                        <InputText
                                            disabled
                                            placeholder="Nome"
                                            name="Nome"
                                            value={
                                                Associado.Nome
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Telefone"
                                        className="p-col-fixed p-col-12 p-md-3"
                                    >
                                    Celular
                                    </label>
                                    <div className="p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="Celular"
                                            value={
                                                Associado.Celular
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Telefone"
                                        className="p-col-fixed p-col-12 p-md-3"
                                    >
                                    Telefone
                                    </label>
                                    <div className="p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="Telefone"
                                            value={
                                                Associado.Telefone
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Email"
                                        className="p-col-fixed p-col-12 p-md-3"
                                    >
                                    Email
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="AssEmail"
                                            value={
                                                Associado.AssEmail
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                        style={{
                                            letterSpacing:
                                            '-0.5px'
                                        }}
                                    >
                                    Nascimento
                                    </label>
                                    <div className="p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="Nascimento"
                                            value={moment(
                                                Associado.Nascimento
                                            )
                                                .add(3, 'hours')
                                                .format(
                                                    'DD/MM/YYYY'
                                                )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Email"
                                        className="p-col-fixed p-col-12 p-md-3 "
                                    >
                                    CPF
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="CPF"
                                            value={
                                                mascaraCpf(Associado.CPF)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                    >
                                    RG
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="RG"
                                            id="RG"
                                            value={Associado.RG}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                    >
                                    Sexo
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            value={
                                                Associado.Sexo
                                            }
                                            name="Sexo"
                                            id="Sexo"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                    >
                                    Estado Civil
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <Dropdown
                                            disabled
                                            value={
                                                Associado.EstadoCivil
                                            }
                                            optionLabel="label"
                                            optionValue="value"
                                            options={
                                                opEstadoCivil
                                            }
                                            name="EstadoCivil"
                                            id="EstadoCivil"
                                            style={{
                                                width: '12em'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                    >
                                    Mãe
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="MaeAssoc"
                                            value={
                                                Associado.MaeAssoc
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                    >
                                    Pai
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="PaiAssoc"
                                            value={
                                                Associado.PaiAssoc
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                    >
                                    Profissão
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="Profissao"
                                            value={
                                                Associado.Profissao
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fieldset>
                    <Fieldset legend="Contrato">
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                    >
                                    SubGrupo
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            value={
                                                Associado.SubGrupo
                                            }
                                            name="SubGrupo"
                                            id="SubGrupo"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                    >
                                    Tipo Cobrança
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <Dropdown
                                            disabled
                                            value={
                                                Associado.AssTipoCobranca
                                            }
                                            options={
                                                opPagamento
                                            }
                                            name="AssTipoCobranca"
                                            id="AssTipoCobranca"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                        style={{
                                            letterSpacing:
                                            '-1px'
                                        }}
                                    >
                                    Tipo Mensalidade
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <Dropdown
                                            disabled
                                            value={
                                                Associado.payzentipomensalidade
                                            }
                                            options={
                                                opMensalidade
                                            }
                                            name="payzentipomensalidade"
                                            id="payzentipomensalidade"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed  p-col-12 p-md-3"
                                        style={{
                                            letterSpacing:
                                            '-1px'
                                        }}
                                    >
                                    Mensalidade Base
                                    </label>
                                    <div className="p-col  p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="Mensalidade"
                                            value={new Intl.NumberFormat(
                                                'pt-BR',
                                                {
                                                    style: 'currency',
                                                    currency:
                                                    'BRL'
                                                }
                                            ).format(
                                                mensalidadeBase
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed  p-col-12 p-md-3"
                                        style={{
                                            letterSpacing:
                                            '-1px'
                                        }}
                                    >
                                    Valor do desconto
                                    </label>
                                    <div className="p-col  p-col-12 p-md-9">
                                        <InputText
                                            className='bordaMensalidadeDesconto'
                                            disabled
                                            name="Mensalidade"
                                            value={new Intl.NumberFormat(
                                                'pt-BR',
                                                {
                                                    style: 'currency',
                                                    currency:
                                                    'BRL'
                                                }
                                            ).format(Associado.valorComDesconto ? Associado.valorComDesconto : '')
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed  p-col-12 p-md-3"
                                        style={{
                                            letterSpacing:
                                            '-1px'
                                        }}
                                    >
                                    Serviços Adicionais
                                    </label>
                                    <div className="p-col  p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="Mensalidade"
                                            value={new Intl.NumberFormat(
                                                'pt-BR',
                                                {
                                                    style: 'currency',
                                                    currency:
                                                    'BRL'
                                                }
                                            ).format(
                                                valorServicosAdicionais
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                        style={{
                                            letterSpacing:
                                            '-1px'
                                        }}
                                    >
                                    Mensalidade Total
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="Mensalidade"
                                            value={somaBase}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed p-col-12 p-md-3"
                                        style={{
                                            letterSpacing:
                                            '-1px'
                                        }}
                                    >
                                    Dia Vencimento
                                    </label>
                                    <div className="p-col p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="DiaVenc"
                                            value={
                                                Associado.DiaVenc
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <div className="p-field p-grid">
                                    <label
                                        htmlFor="Idade"
                                        className="p-col-fixed  p-col-12 p-md-3"
                                    >
                                    Carência
                                    </label>
                                    <div className="p-col  p-col-12 p-md-9">
                                        <InputText
                                            disabled
                                            name="CarenFuneral"
                                            value={moment(
                                                Associado.CarenFuneral
                                            )
                                                .add(3, 'hours')
                                                .format(
                                                    'DD/MM/YYYY'
                                                )}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fieldset>
                </div>
            </div>
            <Fieldset legend="Endereço">
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-4">
                        <div className="p-field p-grid">
                            <label
                                htmlFor="Email"
                                className="p-col-fixed  p-col-12 p-md-3"
                            >
                            CEP
                            </label>
                            <div className="p-col  p-col-12 p-md-9">
                                <InputText
                                    disabled
                                    name="CEPResid"
                                    value={Associado.CEPResid}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="p-field p-grid">
                            <label
                                htmlFor="Email"
                                className="p-col-fixed  p-col-12 p-md-3"
                            >
                            Cidade
                            </label>
                            <div className="p-col  p-col-12 p-md-9">
                                <InputText
                                    disabled
                                    name="Cidade"
                                    value={Associado.Cidade}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="p-field p-grid">
                            <label
                                htmlFor="Email"
                                className="p-col-fixed  p-col-12 p-md-3"
                            >
                            Bairro
                            </label>
                            <div className="p-col  p-col-12 p-md-9">
                                <InputText
                                    disabled
                                    name="Bairro"
                                    value={Associado.Bairro}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="p-field p-grid">
                            <label
                                htmlFor="Email"
                                className="p-col-fixed p-col-12 p-md-3"
                            >
                            Numero
                            </label>
                            <div className="p-col  p-col-12 p-md-9">
                                <InputText
                                    disabled
                                    name="numeroResidencia"
                                    value={
                                        Associado.numeroResidencia
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="p-field p-grid">
                            <label
                                htmlFor="Email"
                                className="p-col-fixed  p-col-12 p-md-3"
                            >
                            Rua/AV
                            </label>
                            <div className="p-col  p-col-12 p-md-9">
                                <InputText
                                    disabled
                                    name="Residencia"
                                    value={Associado.Residencia}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="p-field p-grid">
                            <label
                                htmlFor="Email"
                                className="p-col-fixed  p-col-12 p-md-3"
                                style={{
                                    letterSpacing: '-1.5px'
                                }}
                            >
                            Complemento
                            </label>
                            <div className="p-col  p-col-12 p-md-9">
                                <InputText
                                    disabled
                                    name="Complemento"
                                    value={
                                        Associado?.Complemento.toUpperCase() !== 'NULL'?  Associado.Complemento : ''
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Fieldset>
        </Card>
    </Dialog>;
}
